import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { endPoints } from "../../../config/end-points";
import useHttp from "../../../hooks/use-http";
import { useDispatch } from "react-redux";
import { personalizeAction } from "../../../store/pesonalize-store";
import { authActions } from "../../../store/auth";

const Reports = () => {
  const [showReports, setShowReports] = useState(false);
  const [campName, setCampName] = useState();
  const { camp_id } = useParams();
  const { sendRequest } = useHttp();
  const dispatch = useDispatch();

  const [stats, setStats] = useState({
    total_clicks: null,
    total_full_watch: null,
    total_plays: null,
    total_skips: null,
    unique_visitors: null,
  });

  const responseData = (response) => {
    console.log(response);
    if (response.status && response.status === 200) {
      const temp_stats = response.body.analytics;
      setCampName(response.body.name);
      if (temp_stats.length > 0) {
        if (temp_stats[0].total_plays) {
          setShowReports(true);
        }
        setStats({ ...temp_stats[0] });
        dispatch(
          personalizeAction.setReports({
            personalize_reports: { ...temp_stats[0] },
          })
        );
      }
    }

    dispatch(authActions.setLoaderStatus({ status: false }));
  };
  useEffect(() => {
    sendRequest(
      { url: endPoints.fetchStats + "/" + camp_id, method: "GET" },
      responseData
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [camp_id]);

  return (
    <>
      {!showReports && (
        <div className="reports_sec">
          <div className="row align-items-center">
            <div className="col-sm-12">
              <h5>
                <b className="text-capitalize">{campName}</b> Analytics
              </h5>
            </div>
            <div className="col-md-5">
              <figure className="mb-0">
                <img
                  src={process.env.PUBLIC_URL + "/assets/images/report.png"}
                  className="img-fluid"
                  alt="img"
                />
              </figure>
            </div>
            <div className="col-md-7">
              <figcaption>
                <h4>Currently this video has not been shared.</h4>
                <p className="m-0">
                  Video analytics depending on various parameters will be available once the video landing page is shared on the Internet and viewed by the visitors.
                </p>
              </figcaption>
            </div>
          </div>
        </div>
      )}

      {showReports && (
        <div className="reports_tab">
          <div className="row">
            <div className="col-md-12  mb-5">
              <h5 className="pull-left">
                <b className="text-capitalize">{campName}</b> Analytics
              </h5>
              <a
                href={`${endPoints.downloadCsv}/${camp_id}`}
                rel="noreferrer"
                target="_blank"
                className="btn pull-right"
              >
                Export Leads
              </a>
            </div>
            <div className="col-xl-4 col-lg-6 col-md-12 cursorReport">
              <a
                href="#0"
                className="rt_cl_m bg-white rounded-2 p-3 d-flex align-items-center justify-content-between text-decoration-none"
              >
                <figcaption className="d-flex align-items-center">
                  <i className="me-2">
                    <img
                      src={
                        process.env.PUBLIC_URL +
                        "/assets/images/total_plays.png"
                      }
                      alt="img"
                    />
                  </i>
                  Total Plays
                </figcaption>
                <span className="number_t">{stats.total_plays}</span>
              </a>
            </div>

            <div className="col-xl-4 col-lg-6 col-md-12 cursorReport">
              <a
                href="#0"
                className="rt_cl_m bg-white rounded-2 p-3 d-flex align-items-center justify-content-between text-decoration-none"
              >
                <figcaption className="d-flex align-items-center">
                  <i className="me-2">
                    <img
                      src={
                        process.env.PUBLIC_URL +
                        "/assets/images/unique_viewers.png"
                      }
                      alt="img"
                    />
                  </i>
                  Unique Viewers
                </figcaption>
                <span className="number_t">{stats.unique_visitors}</span>
              </a>
            </div>

            <div className="col-xl-4 col-lg-6 col-md-12 cursorReport">
              <a
                href="#0"
                className="rt_cl_m bg-white rounded-2 p-3 d-flex align-items-center justify-content-between text-decoration-none"
              >
                <figcaption className="d-flex align-items-center">
                  <i className="me-2">
                    <img
                      src={
                        process.env.PUBLIC_URL + "/assets/images/watch_rate.png"
                      }
                      alt="img"
                    />
                  </i>
                  Avg Watch Rate
                </figcaption>
                <span className="number_t">
                  {stats.total_full_watch % stats.unique_visitors}%
                </span>
              </a>
            </div>

            <div className="col-xl-4 col-lg-6 col-md-12 cursorReport">
              <a
                href="#0"
                className="rt_cl_m bg-white rounded-2 p-3 d-flex align-items-center justify-content-between text-decoration-none"
              >
                <figcaption className="d-flex align-items-center">
                  <i className="me-2">
                    <img
                      src={
                        process.env.PUBLIC_URL +
                        "/assets/images/fully_watched.png"
                      }
                      alt="img"
                    />
                  </i>
                  Fully Watched
                </figcaption>
                <span className="number_t">{stats.total_full_watch}</span>
              </a>
            </div>

            <div className="col-xl-4 col-lg-6 col-md-12 cursorReport">
              <a
                href="#0"
                className="rt_cl_m bg-white rounded-2 p-3 d-flex align-items-center justify-content-between text-decoration-none"
              >
                <figcaption className="d-flex align-items-center">
                  <i className="me-2">
                    <img
                      src={
                        process.env.PUBLIC_URL +
                        "/assets/images/popular_region.png"
                      }
                      alt="img"
                    />
                  </i>
                  Popular Regions
                </figcaption>
                <span className="number_t">{stats.total_skips}</span>
              </a>
            </div>

            <div className="col-xl-4 col-lg-6 col-md-12 cursorReport">
              <a
                href="#0"
                className="rt_cl_m bg-white rounded-2 p-3 d-flex align-items-center justify-content-between text-decoration-none"
              >
                <figcaption className="d-flex align-items-center">
                  <i className="me-2">
                    <img
                      src={process.env.PUBLIC_URL + "/assets/images/action.png"}
                      alt="img"
                    />
                  </i>
                  Action
                </figcaption>
                <span className="number_t">{stats.total_clicks}</span>
              </a>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Reports;
